<template>
    <div>
        <template v-if="data">
            <div class="nj-cols" style="align-items: center; gap: 2px; grid-template-columns:  40px 4px 40px 4px 60px">
                <input type="text" class="nj-text nj-text-center" v-model="data.day" :disabled="disabled" :placeholder="showPlaceholders ? 'dia' : ''" maxlength="2">
                <span class="nj-text-center">-</span>
                <input type="text" class="nj-text nj-text-center" v-model="data.month" :disabled="disabled" :placeholder="showPlaceholders ? 'mes' : ''" maxlength="2">
                <span class="nj-text-center">-</span>
                <input type="text" class="nj-text nj-text-center" v-model="data.year" :disabled="disabled" :placeholder="showPlaceholders ? 'año' : ''" maxlength="4">
            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: "Fecha",
    props: {
        data: {
            type: Object
        },
        disabled: {
            type: Boolean,
            default: false
        },
        showPlaceholders: {
            type: Boolean,
            default: true
        }
    }
}
</script>

<style scoped></style>